export const PROFILE_EDUCATION_ERROR = 'PROFILE_EDUCATION_ERROR';
export const PROFILE_EDUCATION_LOADING = 'PROFILE_EDUCATION_LOADING';
export const PROFILE_EDUCATION_SUCCESS = 'PROFILE_EDUCATION_SUCCESS';